import appTemplate from 'components/app/app.html';
import homeTemplate from 'components/home/home.html';
import searchTemplate from 'components/search/search.html';
import aboutTemplate from 'components/about/about.html';
import conciergeTemplate from 'components/concierge/concierge.html';
import faqTemplate from 'components/faq/faq.html';
// import connectTemplate from 'components/connect/connect.html';
import tableServiceTemplate from 'components/tableservice/tableservice.html';
// import couponsTemplate from 'components/coupons/coupons.html';
import legalTemplate from 'components/legal/legal.html';
import privacyTemplate from 'components/legal/privacy/privacy.html';
//browse
import browseTemplate from 'components/browse/browse.html';
import browseCityTemplate from 'components/browseCity/browseCity.html';
import browseEventsTemplate from 'components/browseEvents/browseEvents.html';
import browseVenuesTemplate from 'components/browseVenues/browseVenues.html';
//curated lists
import curatedListTemplate from 'components/curatedList/curatedList.html';
import curatedListsHalloweenTemplate from 'components/curatedListsHalloween/curatedListsHalloween.html';
import curatedListsNewYearsTemplate from 'components/curatedListsNewYears/curatedListsNewYears.html';
//membership
// import membershipTemplate from 'components/membership/membership.html';
// import membershipLandingTemplate from 'components/membershipLanding/membershipLanding.html';
// import membershipStartTemplate from 'components/membershipStart/membershipStart.html';
// import membershipSuccessTemplate from 'components/membershipSuccess/membershipSuccess.html';
// import membershipPerksTemplate from 'components/membershipPerks/membershipPerks.html';
//account
import accountTemplate from 'components/account/account.html';
// import accountDashboardTemplate from 'components/accountDashboard/accountDashboard.html';
import accountProfileTemplate from 'components/accountProfile/accountProfile.html';
import accountBookingTemplate from 'components/accountBooking/accountBooking.html';
import accountFavoritesTemplate from 'components/accountFavorites/accountFavorites.html';
import accountTicketsTemplate from 'components/accountTickets/accountTickets.html';
import accountReviewsTemplate from 'components/accountReviews/accountReviews.html';
import accountReviewTemplate from 'components/accountReview/accountReview.html';
import accountPromoTemplate from 'components/accountPromo/accountPromo.html';
//venues
import venueTemplate from 'components/venue/venue.html';
import venueEventsTemplate from 'components/venueEvents/venueEvents.html';
import venueInfoTemplate from 'components/venueInfo/venueInfo.html';
//events
import eventTemplate from 'components/event/event.html';
//checkout
import checkoutTemplate from 'components/checkout/checkout.html';
import receiptTemplate from 'components/receipt/receipt.html';
//login
import signupTemplate from 'components/signup/signup.html';
//
import errorNotFoundTemplate from 'components/errorNotFound/errorNotFound.html';
import errorServerTemplate from 'components/errorServer/errorServer.html';
import downloadTemplate from 'components/download/download.html';
import forgotPasswordTemplate from 'components/forgotPassword/forgotPassword.html';
import resetPasswordTemplate from 'components/resetPassword/resetPassword.html';
import termsTemplate from 'components/terms/terms.html';

function configureRoutes($stateProvider) {
  $stateProvider
    .state('app', {
      url: '',
      controller: 'appCtrl',
      template: appTemplate,
      resolve: {
        currentUser: [
          'jsSdk.user',
          'jsSdk.auth',
          '$q',
          (userService, authService, $q) => {
            if (!authService.isLoggedIn()) {
              return $q.resolve(null);
            }

            return userService.me();
          }
        ]
      }
    })
    .state('app.home', {
      url: '/',
      template: homeTemplate,
      controller: 'homeCtrl'
    })
    .state('app.search', {
      url: '/search?cityId&guestsMin&guestsMax&date&priceMin&priceMax',
      template: searchTemplate,
      controller: 'searchCtrl'
    })
    .state('app.about', {
      url: '/about',
      template: aboutTemplate,
      controller: 'aboutCtrl'
    })
    .state('app.concierge', {
      url: '/concierge',
      template: conciergeTemplate,
      controller: 'conciergeCtrl'
    })
    .state('app.faq', {
      url: '/faq',
      template: faqTemplate,
      controller: 'faqCtrl'
    })
    // .state('app.connect', {
    //   url: '/connect',
    //   template: connectTemplate,
    //   controller: 'connectCtrl'
    // })
    .state('app.tableservice', {
      url: '/bottleservice101',
      template: tableServiceTemplate,
      controller: 'tableserviceCtrl'
    })
    // .state('app.coupons', {
    //   url: '/coupons',
    //   template: couponsTemplate,
    //   controller: 'couponsCtrl'
    // })
    // .state('app.earnCredit', {
    //   url: '/earn-credit',
    //   template: earnCreditTemplate,
    //   controller: 'earnCreditCtrl'
    // })
    .state('app.legal', {
      template: legalTemplate
    })
    .state('app.legal.privacy', {
      url: '/legal/privacy',
      template: privacyTemplate
    })
    .state('app.browse', {
      abstract: true,
      template: browseTemplate,
      controller: 'browseCtrl'
    })
    .state('app.browse.city', {
      url: '/:city/discover/',
      template: browseCityTemplate,
      controller: 'browseCityCtrl'
    })
    .state('app.browse.events', {
      url: '/:city/events/:tag?date',
      template: browseEventsTemplate,
      controller: 'browseEventsCtrl'
    })
    .state('app.browse.venues', {
      url: '/:city/venues/?date&sort',
      template: browseVenuesTemplate,
      controller: 'browseVenuesCtrl'
    })
    .state('app.curatedList', {
      url: '/list/:id',
      template: curatedListTemplate,
      controller: 'curatedListCtrl'
    })
    .state('app.curatedListWithCityHalloween', {
      url: '/halloween/:city',
      template: curatedListsHalloweenTemplate,
      controller: 'curatedListHalloweenCtrl',
      reloadOnSearch: false
    })
    .state('app.curatedListWithCityNewYears', {
      url: '/newyears/:city',
      template: curatedListsNewYearsTemplate,
      controller: 'curatedListsNewYearsCtrl',
      reloadOnSearch: false
    })
    // .state('app.membership', {
    //   abstract: true,
    //   template: membershipTemplate,
    //   controller: 'membershipCtrl'
    // })
    // .state('app.membership.landing', {
    //   url: '/membership',
    //   template: membershipLandingTemplate,
    //   controller: 'membershipLandingCtrl'
    // })
    // .state('app.membership.start', {
    //   url: '/membership/start',
    //   template: membershipStartTemplate,
    //   controller: 'membershipStartCtrl'
    // })
    // .state('app.membership.success', {
    //   url: '/membership/thanks',
    //   template: membershipSuccessTemplate,
    //   controller: 'membershipSuccessCtrl'
    // })
    // .state('app.membership.perks', {
    //   url: '/membership/perks',
    //   template: membershipPerksTemplate,
    //   controller: 'membershipPerksCtrl'
    // })
    .state('app.me', {
      abstract: true,
      template: accountTemplate,
      controller: 'accountCtrl',
      authenticate: true
    })
    // .state('app.me.dashboard', {
    //   url: '/dashboard',
    //   template: accountDashboardTemplate,
    //   controller: 'accountDashboardCtrl',
    //   authenticate: true
    // })
    .state('app.me.profile', {
      url: '/profile/:action?section&pastDue',
      template: accountProfileTemplate,
      controller: 'accountProfileCtrl',
      authenticate: true
    })
    .state('app.me.bookings', {
      url: '/booking',
      template: accountBookingTemplate,
      controller: 'accountBookingCtrl',
      authenticate: true
    })
    .state('app.me.favorites', {
      url: '/favorites',
      template: accountFavoritesTemplate,
      controller: 'accountFavoritesCtrl',
      authenticate: true
    })
    .state('app.me.tickets', {
      url: '/tickets',
      template: accountTicketsTemplate,
      controller: 'accountTicketsCtrl',
      authenticate: true
    })
    .state('app.me.reviews', {
      url: '/reviews',
      template: accountReviewsTemplate,
      controller: 'accountReviewsCtrl',
      authenticate: true
    })
    .state('app.me.review', {
      url: '/review/:reviewId',
      template: accountReviewTemplate,
      controller: 'accountReviewCtrl',
      authenticate: true
    })
    .state('app.me.promo', {
      url: '/promo',
      template: accountPromoTemplate,
      controller: 'accountPromoCtrl',
      authenticate: true
    })
    .state('app.me.promos', {
      url: '/promo/:code',
      template: accountPromoTemplate,
      controller: 'accountPromoCtrl',
      authenticate: true
    })
    .state('app.venue', {
      url: '/v/:seoPathname?book&back&backName',
      template: venueTemplate,
      controller: 'venueCtrl'
    })
    .state('app.venueOld', {
      url: '/venues/:name?book',
      template: venueTemplate,
      controller: 'venueCtrl'
    })
    .state('app.venue.events', {
      url: '/events',
      template: venueEventsTemplate,
      controller: 'venueEventsCtrl'
    })
    .state('app.venueOld.events', {
      url: '/events',
      template: venueEventsTemplate,
      controller: 'venueEventsCtrl'
    })
    .state('app.venue.info', {
      url: '/:page',
      template: venueInfoTemplate,
      controller: 'venueInfoCtrl'
    })
    .state('venueOld.info', {
      url: '/:page',
      template: venueInfoTemplate,
      controller: 'venueInfoCtrl'
    })
    .state('app.eventOld', {
      url: '/event/:eventId?book',
      template: eventTemplate,
      controller: 'eventCtrl'
    })
    .state('app.event', {
      url: '/e/:seoPathname?book&back&backName',
      template: eventTemplate,
      controller: 'eventCtrl'
    })
    .state('app.checkout', {
      url: '/checkout/:bookingId?theme',
      template: checkoutTemplate,
      controller: 'checkoutCtrl'
    })
    .state('app.checkout-widget', {
      url: '/checkout-widget/:bookingId?theme',
      template: checkoutTemplate,
      controller: 'checkoutCtrl'
    })
    .state('app.receipt', {
      url: '/booking/:booking?isNew',
      template: receiptTemplate,
      controller: 'receiptCtrl',
      authenticate: true
    })
    .state('app.signup', {
      url: '/signup/:code?redirectState&redirectParams',
      template: signupTemplate,
      controller: 'signupCtrl'
    })
    .state('app.login', {
      url: '/login?redirectState&redirectParams&redirectUrl',
      template: signupTemplate,
      controller: 'signupCtrl'
    })
    .state('app.logout', {
      url: '/logout',
      controller: [
        '$rootScope',
        ($rootScope) => {
          $rootScope.logout();
        }
      ]
    })
    .state('app.404', {
      url: '/404?target&message',
      params: {
        message: null
      },
      template: errorNotFoundTemplate,
      controller: 'errorNotFoundCtrl'
    })
    .state('app.400', {
      url: '/400?message',
      params: {
        message: null
      },
      template: errorServerTemplate,
      controller: 'errorServerCtrl'
    })
    .state('app.download', {
      url: '/download',
      template: downloadTemplate,
      controller: 'downloadCtrl'
    })
    .state('app.forgot-password', {
      url: '/forgot-password',
      template: forgotPasswordTemplate,
      controller: 'forgotPasswordCtrl'
    })
    .state('app.reset-password', {
      url: '/reset-password/:resetToken',
      template: resetPasswordTemplate,
      controller: 'resetPasswordCtrl'
    })
    .state('app.terms', {
      url: '/terms',
      template: termsTemplate,
      controller: [
        '$scope',
        'metaTagService',
        ($scope, metaTagService) => {
          metaTagService.set({
            title: 'Terms of Use | Tablelist',
            description: 'These terms of use apply to any and all use of the Tablelist website, applications, services, features, content, and tools.'
          });
        }
      ]
    });
}

function RouterConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  if (window.history && window.history.pushState) {
    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix('!');
  }

  $urlRouterProvider.when('', '/');

  $urlRouterProvider.otherwise(($injector, $location) => {
    let path = '/404';

    if ($location && $location.$$absUrl) {
      path += `?target=${$location.$$absUrl}`;
    }

    return path;
  });

  configureRoutes($stateProvider);

  //REDIRECTS
  $urlRouterProvider.when('/:city/events?date', '/:city/events/?date');
  $urlRouterProvider.when('/:city/venues?date&sort', '/:city/venues/?date&sort');
  $urlRouterProvider.when('/events', '/venue');
  $urlRouterProvider.when('/event', '/venue');
  $urlRouterProvider.when('/venue/:id?book', '/venues/:id?book');
  $urlRouterProvider.when('/profile', '/profile/');
  $urlRouterProvider.when('/share', '/dashboard');
  $urlRouterProvider.when('/membership/:id', '/membership');
  $urlRouterProvider.when('/membership/:id/start', '/membership/start');
  $urlRouterProvider.when('/membership/my-membership', '/membership/perks');
  $urlRouterProvider.when('/login/', '/login');
  $urlRouterProvider.when('/signup', '/signup/');
  $urlRouterProvider.when('/invite', '/signup/');
  $urlRouterProvider.when('/invite/:code?redirectState&redirectParams', '/signup/:code?redirectState&redirectParams');
  $urlRouterProvider.when('/support', '/faq');
  $urlRouterProvider.when('/book', '/venue');
  $urlRouterProvider.when('/city', '/venue');
  $urlRouterProvider.when('/bookings', '/booking');
  $urlRouterProvider.when('/account', '/me');
  // $urlRouterProvider.when('/membership', '/membership/');

  $urlRouterProvider.when('/home', '/');
  $urlRouterProvider.when('/appstore', '/download');
  $urlRouterProvider.when('/events', '/download');
  $urlRouterProvider.when('/event', '/download');
  $urlRouterProvider.when('/reward', '/download');
  $urlRouterProvider.when('/rewards', '/download');
  $urlRouterProvider.when('/tableservice', '/bottleservice101');
  $urlRouterProvider.when('/company', '/about');
  $urlRouterProvider.when('/legal', '/legal/privacy');

  $urlRouterProvider.when('/newyears', '/newyears/')
    .when('/halloween', '/halloween/');

  // // Old Browse URL
  // .when('/cities/:city', '/:city/venues/')
  // .when('/cities/', '/:city/venues/')
  // .when('/cities', '/:city/venues/')
  // .when('/venues/', '/nyc/venues/')
  // .when('/venues', '/nyc/venues/')
  //
  // // Old Browse Url
  // .when('/:city/city', '/:city/discover/')
  // .when('/:city/city', '/:city/discover/')
  // .when('/:city/discover', '/:city/discover/');
}

RouterConfig.$inject = [
  '$stateProvider',
  '$urlRouterProvider',
  '$locationProvider'
];

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/routerConfig.js